// extracted by mini-css-extract-plugin
export var container = "emso-Disclaimer-module__container emso-page-module__page";
export var disclaimer = "emso-Disclaimer-module__disclaimer";
export var disclaimerActions = "emso-Disclaimer-module__disclaimerActions";
export var disclaimerParagraph = "emso-Disclaimer-module__disclaimerParagraph";
export var fadeIn = "emso-Disclaimer-module__fadeIn";
export var header = "emso-Disclaimer-module__header";
export var proceed = "emso-Disclaimer-module__proceed";
export var visible = "emso-Disclaimer-module__visible";
export var wrapper = "emso-Disclaimer-module__wrapper";